module.exports = __webpack_public_path__ + "img/sixpackcarrier69.8ed6e8ce.jpg";